__webpack_require__.p = "/energy/paper/Carbon_seq/";